/**
 * TestConnectionBanner.jsx (868m4z3q0)
 *
 * Thin wrapper on DeviceCard + the existing .status-card success/warning/
 * danger/info variants (design-system.css) -- gives a controller's Test
 * Connection result the visual weight of a real state instead of the
 * previous thin .im-review__test-badge pill. No new colors: success/danger
 * reuse --accent-success/--accent-danger the same way .status-card's own
 * border-left coding already does, and the loading state's "info" variant
 * matches the accent-toned treatment used elsewhere for an in-progress
 * state (e.g. .im-step--active).
 */

import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import DeviceCard from './DeviceCard';

export default function TestConnectionBanner({ testing, result }) {
  if (!testing && !result) return null;

  if (testing) {
    return (
      <DeviceCard className="status-card info cm-test-banner">
        <Loader2 size={18} className="spin cm-test-banner__icon cm-test-banner__icon--info" />
        <span className="cm-test-banner__message">Testing connection...</span>
      </DeviceCard>
    );
  }

  const ok = result.ok;
  const Icon = ok ? CheckCircle2 : XCircle;
  return (
    <DeviceCard className={`status-card ${ok ? 'success' : 'danger'} cm-test-banner`}>
      <Icon size={18} className={`cm-test-banner__icon cm-test-banner__icon--${ok ? 'success' : 'danger'}`} />
      <span className="cm-test-banner__message">{result.message}</span>
    </DeviceCard>
  );
}
